// src/app/auth/loading.js

"use client";
// src/app/auth/loading.js
import React from "react";
import Image from "next/image";

function Loading() {
  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-100">
      <div className="spin">
        <Image
          src="/images/IsotypeLogo.png"
          alt="Loading"
          width={64}
          height={64}
        />
      </div>
    </div>
  );
}

export default Loading;
